import React from "react";

import type { ServiceInterface } from "types/service";
import { ProviderListCard } from "./ProviderListCard";

export const SERVICE_LIST_GRID_CLASS = "grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3";

interface Props {
    items: ServiceInterface[];
    gridClassName?: string;
}

const ComponentList: React.FC<Props> = ({ items, gridClassName = SERVICE_LIST_GRID_CLASS }) => (
    <div className={gridClassName}>
        {items.map((service) => (
            <ProviderListCard key={service.provider_id} service={service} />
        ))}
    </div>
);

export default ComponentList;

/** @deprecated Use ProviderListCard */
export { ProviderListCard as ServiceCard } from "./ProviderListCard";
